<form (submit)="doSearch()" [formGroup]="searchForm" fxLayout="row" fxLayoutAlign="center center">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Buscar Edicto</mat-card-title>
    </mat-card-header>
    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
      <mat-form-field fxFlex="100" fxFlex.lg="calc(50% - 10px)">
        <input matInput placeholder="Término de búsqueda" formControlName="term">
      </mat-form-field>
      <mat-form-field fxFlex="calc(50% - 10px)" fxFlex.lg="calc(25% - 10px)">
        <input matInput [max]="searchForm.get('endDate').value" [matDatepicker]="fromPicker" (focus)="fromPicker.open()"
          placeholder="Desde" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field fxFlex="calc(50% - 10px)" fxFlex.lg="calc(25% - 10px)">
        <input matInput [min]="searchForm.get('startDate').value" [matDatepicker]="toPicker" (focus)="toPicker.open()"
          placeholder="Hasta" formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions fxLayoutAlign="end center">
      <button mat-raised-button>Buscar</button>
    </mat-card-actions>
  </mat-card>
</form>
<div *ngIf="searchResults">
  <mat-table #table [dataSource]="searchResults.edicts">
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dates">
      <mat-header-cell *matHeaderCellDef> Fechas </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx">
          <h6 *ngFor="let d of element.publishDates" [innerText]="d | date:'yyyy/MM/dd' "> </h6>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="match">
      <mat-header-cell *matHeaderCellDef> Fragmento </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.matchText}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element" fxLayout="row" fxLayoutAlign="center center">
        <button mat-icon-button [routerLink]="element.id" ><mat-icon>picture_as_pdf</mat-icon></button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>
